import DrfRestBase from './drf_rest_base';

export default class ApiBranch extends DrfRestBase{
    static endpoint='/shop/api/branches/';
}
